import {  useMemo } from "react";
import TableContainer from "Common/TableContainer";
import { Button } from "react-bootstrap";
import { settingServices } from "Utils/setting/services";
import snackbarUtil from "Utils/snackBarUtil";


const InProgressMatchResult = ({data,fancy}:any) => {

  const resetStruckResult = (async(id:string)=>{
    try{
      const payload = {"id":id,"type":"RESULT","isFancy":fancy}
      const {response} = await settingServices.resetStruckResult(payload)
      if(response?.status){
        snackbarUtil.success(response?.msg)
      }else{
        snackbarUtil.error(response?.msg)

      }
    }catch(error){
      console.log(error)
    }
  })

 




  const columns = useMemo(
    () => [
      {
        header: "S.no.",
        accessorKey: "no",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return cell.row.index + 1;
        },
      },
      {
        header: "Match",
        accessorKey: "match_name",
        enableColumnFilter: false,
        cell: (cell: any) => cell.row.original?.match_name,
      },
      {
        header: "Match Id",
        accessorKey: "match_id",
        enableColumnFilter: false,
        cell: (cell: any) => cell.row.original?.match_id,
      },
      {
        header: "Fancy Name",
        accessorKey: "fancy_name",
        enableColumnFilter: false,
        cell: (cell: any) => cell.row.original?.fancy_name,
      },
      {
        header: "Fancy Id",
        accessorKey: "fancy_id",
        enableColumnFilter: false,
        cell: (cell: any) => cell.row.original?.fancy_id,
      },
      {
        header: "Is Processing",
        accessorKey: "is_processing",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span>{cell.row.original?.is_processing ? "Yes" : "No"}</span>
        ),
      },
      {
        header: "Processing Message",
        accessorKey: "processing_message",
        enableColumnFilter: false,
        cell: (cell: any) => <span>{cell.row.original?.processing_message}</span>,
      },
      {
        header: "Bull Job Count",
        accessorKey: "bull_job_count",
        enableColumnFilter: false,
        cell: (cell: any) => <span>{cell.row.original?.bull_job_count}</span>,
      },
      {
        header: "Cron Progress",
        accessorKey: "cron_progress",
        enableColumnFilter: false,
        cell: (cell: any) => <span>{cell.row.original?.cron_progress}</span>,
      },
      {
        header: "Cron Progress Message",
        accessorKey: "cron_progress_message",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span>{cell.row.original?.cron_progress_message}</span>
        ),
      },
      {
        header: "Status",
        accessorKey: "status",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const row = cell.row.original?.fancy_id;
          return (
            <div className="d-flex flex-column gap-1">
         
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => resetStruckResult(row)}
                >
                  Retry
                </Button>
          
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <TableContainer
        columns={columns}
        data={data}
        isBordered={false}
        isPagination={false}
        sorting={true}
        tableClass="table-centered align-middle table-nowrap table-striped mb-3"
        theadClass="text-muted table-light"
        SearchPlaceholder="Search Products..."
      />
    </>
  );
};

export default InProgressMatchResult;







// import { useEffect, useState, useMemo } from "react";
// import moment from "moment";
// import TableContainer from "Common/TableContainer";
// import { Button } from "react-bootstrap";
// import { settingServices } from "Utils/setting/services"; // Adjust path as needed

// const InProgressMatchResult = () => {
//   const [resultProgressData, setResultProgressData] = useState<any[]>([]); // State to store the fetched data

//   const getResultProgress = async () => {
//     try {
//       const payload = {
//         type: "RESULT",
//       };
//       const { response } = await settingServices.getResultProgress(payload);
//       console.log(response, "response");
//       setResultProgressData(response?.data); // Set the fetched data to state
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     getResultProgress(); // Fetch data on component mount
//   }, []);

//   const handleRetry = (rowData: any) => {
//     // Add your retry logic here (API call, snackbar, etc.)
//     console.log("Retry clicked for:", rowData);
//   };

//   const columns = useMemo(
//     () => [
//       {
//         header: "S.no.",
//         accessorKey: "no",
//         enableColumnFilter: false,
//         cell: (cell: any) => {
//           return cell.row.index + 1;
//         },
//       },
//       {
//         header: "Match",
//         accessorKey: "match_name",
//         enableColumnFilter: false,
//         cell: (cell: any) => cell.row.original?.match_name,
//       },
//       {
//         header: "Match Id",
//         accessorKey: "match_id",
//         enableColumnFilter: false,
//         cell: (cell: any) => cell.row.original?.match_id,
//       },
//       {
//         header: "Fancy Name",
//         accessorKey: "fancy_name",
//         enableColumnFilter: false,
//         cell: (cell: any) => cell.row.original?.fancy_name,
//       },
//       {
//         header: "Fancy Id",
//         accessorKey: "fancy_id",
//         enableColumnFilter: false,
//         cell: (cell: any) => cell.row.original?.fancy_id,
//       },
//       {
//         header: "Is Processing",
//         accessorKey: "is_processing",
//         enableColumnFilter: false,
//         cell: (cell: any) => (
//           <span>{cell.row.original?.is_processing ? "Yes" : "No"}</span>
//         ),
//       },
//       {
//         header: "Processing Message",
//         accessorKey: "processing_message",
//         enableColumnFilter: false,
//         cell: (cell: any) => <span>{cell.row.original?.processing_message}</span>,
//       },
//       {
//         header: "Bull Job Count",
//         accessorKey: "bull_job_count",
//         enableColumnFilter: false,
//         cell: (cell: any) => <span>{cell.row.original?.bull_job_count}</span>,
//       },
//       {
//         header: "Cron Progress",
//         accessorKey: "cron_progress",
//         enableColumnFilter: false,
//         cell: (cell: any) => <span>{cell.row.original?.cron_progress}</span>,
//       },
//       {
//         header: "Cron Progress Message",
//         accessorKey: "cron_progress_message",
//         enableColumnFilter: false,
//         cell: (cell: any) => (
//           <span>{cell.row.original?.cron_progress_message}</span>
//         ),
//       },
//       {
//         header: "Status",
//         accessorKey: "status",
//         enableColumnFilter: false,
//         cell: (cell: any) => {
//           const row = cell.row.original;
//           return (
//             <div className="d-flex flex-column gap-1">
//               <span>{row?.status}</span>
//               {row?.status === "Failed" && (
//                 <Button
//                   variant="danger"
//                   size="sm"
//                   onClick={() => handleRetry(row)}
//                 >
//                   Retry
//                 </Button>
//               )}
//             </div>
//           );
//         },
//       },
//     ],
//     []
//   );

//   return (
//     <>
//       <TableContainer
//         columns={columns}
//         data={resultProgressData} // Use the data from API
//         isBordered={false}
//         isPagination={false}
//         sorting={true}
//         tableClass="table-centered align-middle table-nowrap table-striped mb-3"
//         theadClass="text-muted table-light"
//         SearchPlaceholder="Search Products..."
//       />
//     </>
//   );
// };

// export default InProgressMatchResult;


